import Lang from '@/modules/core/app/services/Lang';
import { FormSelectConfig } from '@/modules/core/form/models/FormSelectConfig';
import { LawyerStatus } from '@/modules/lawyer/enums/LawyerStatus';

export class WorkflowLawyerStatusFormSelectConfig extends FormSelectConfig {
  constructor(config: Params = {}) {
    super({
      placeholder: Lang.t('core.select'),
      ...config
    });
  }

  async getOptions(): Promise<LawyerStatus[]> {
    return LawyerStatus.getValues();
  }
}
